import { Button, MuiThemeProvider, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import Alert from 'components/Shared/Alert';
import ImageSelector from 'components/Shared/ImageSelector';
import { WithStyles } from 'decorators/withStyles';
import { getCdnImage } from 'helpers/isJson';
import { PureComponent } from 'react';
import * as React from 'react';

interface IProps {
  classes?: any;
  recomendations: { width: number; height: number };
  onChangeImage: Function;
  image: string;
  previewDimensions?: { width: string; height: string };
}

interface IState {
  openImageSelector: boolean;
  openDialog: boolean;
}

@WithStyles(theme => ({
  addButton: {
    backgroundColor: theme.variables.colors['primaryColor'],
    color: '#FFF',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    '&:hover': {
      backgroundColor: theme.variables.colors['customizerTitle']
    }
  },
  removeButton: {
    color: '#DC3F53',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    border: '2px solid #DC3F53',
    padding: '6px 20px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#c33345',
      borderColor: '#c33345'
    }
  },
  image: {
    width: '100%',
    height: 200,
    backgroundColor: '#EEEEEE',
    borderRadius: 4
  },
  imagePreview: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  recomendations: {
    fontSize: 16
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))
export default class ImagePicker extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      openImageSelector: false,
      openDialog: false
    };
  }

  onSelectorComplete = (image: string) => {
    if (image) {
      this.props.onChangeImage(image);
    }

    this.setState({ openImageSelector: false });
  };

  openImageSelector = () => {
    this.setState({ openImageSelector: true });
  };

  removeImage = () => {
    this.props.onChangeImage(null);
  };

  handleCloseDialog = (ok: boolean) => {
    if (ok) {
      this.removeImage();
    }

    this.setState({ openDialog: false });
  };

  handleOpenDialog = () => {
    this.setState({ openDialog: true });
  };

  render() {
    const { openImageSelector, openDialog } = this.state;
    const { recomendations, image, previewDimensions } = this.props;
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div
          className={classes.image}
          style={previewDimensions && { width: previewDimensions.width, height: previewDimensions.height }}
        >
          {image && <img src={getCdnImage(image)} className={classes.imagePreview} />}
        </div>

        {image ? (
          <div className={classes.buttons}>
            <Button variant="raised" className={classes.addButton} onClick={this.openImageSelector}>
              Alterar
            </Button>
            <Button className={classes.removeButton} onClick={this.handleOpenDialog}>
              Remover
            </Button>
          </div>
        ) : (
          <Button variant="raised" className={classes.addButton} onClick={this.openImageSelector}>
            Adicionar Imagem
          </Button>
        )}

        <Typography variant="body1" className={classes.recomendations} gutterBottom>
          Formatos Recomendados: <br />
          JPG, PNG <br />
          {recomendations.width}px de largura <br />
          {recomendations.height}px de altura <br />
        </Typography>

        <ImageSelector
          opened={openImageSelector}
          width={recomendations.width}
          height={recomendations.height}
          onComplete={this.onSelectorComplete}
        />

        <Alert
          opened={openDialog}
          title={'Remover imagem'}
          message={'Deseja realmente remover esta imagem?'}
          confirmation
          onClose={this.handleCloseDialog}
        />
      </MuiThemeProvider>
    );
  }
}
